import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';

export function NewVideoCard() {
  useLanguage();
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate('/new-video')}
      // Altura alinhada ao FeedVideoCard (214px) para os cards não desalinharem no grid
      className="
        cursor-pointer rounded-[14px] overflow-hidden
        bg-muted/50 border-2 border-dashed border-border
        hover:border-primary hover:bg-primary/5
        hover:shadow-[0_8px_20px_rgba(0,0,0,0.08)]
        transition-all duration-[250ms]
        animate-fade-in
        h-[214px]
        flex flex-col items-center justify-center gap-3
      "
    >
      <div className="
        w-12 h-12 rounded-full
        bg-primary/10
        flex items-center justify-center
        transition-colors duration-200
      ">
        <Plus className="w-6 h-6 text-primary" />
      </div>
      <span className="text-[14px] font-semibold text-foreground">
        {translateInterfaceText("Novo Vídeo")}</span>
    </div>
  );
}
